import {
  GET_TERMS_PRIVACY_DATA,
  GET_TERMS_PRIVACY_DATA_SUCCESS,
  GET_TERMS_PRIVACY_DATA_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getTermsPrivacyDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TERMS_PRIVACY_DATA:
      return { ...state, loading: true };
    case GET_TERMS_PRIVACY_DATA_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_TERMS_PRIVACY_DATA_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getTermsPrivacyDataReducer;
